// extracted by mini-css-extract-plugin
export default {"custom-button":"BuySubscriptionModal_custom-button__cfSlF","spin-container":"BuySubscriptionModal_spin-container__thGT0","spin-message":"BuySubscriptionModal_spin-message__-ZXl4"};